import PropTypes from 'prop-types';

export const customerPropTypes = PropTypes.exact({
  domain: PropTypes.string,
  id: PropTypes.number,
  instances_count: PropTypes.number,
  payments_count: PropTypes.number,
  type_crm: PropTypes.string
});
